import React from 'react';
import { createPortal } from 'react-dom';

/* Spegnere una linea che sta lavorando non interrompe niente: il numero che ha in mano
   viene finito, poi quella linea si chiude e il lotto prosegue sulle altre. Chi preme
   l'interruttore deve saperlo PRIMA, altrimenti resta col dubbio di aver troncato una
   verifica a metà. */

export function avvisoSpegnimento(linea) {
  const nome = (linea && linea.nome) || 'questa linea';
  const numero = linea && linea.numero_corrente;
  if (!numero) {
    return `«${nome}» non sta lavorando: si ferma subito. I numeri già fatti restano.`;
  }
  return `«${nome}» sta verificando ${numero}. Finisce questo numero, poi si chiude: il lavoro prosegue sulle altre linee.`;
}

export default function LineaSpegniDialog({ linea, onAnnulla, onConferma }) {
  if (!linea) return null;
  return createPortal(
    <div onClick={onAnnulla}
      style={{ position: 'fixed', inset: 0, zIndex: 12000, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()}
        style={{ width: 'min(430px,100%)', background: 'var(--panel,#fff)', color: 'var(--text)', border: '1px solid var(--line)', borderRadius: 14, padding: 20, boxShadow: '0 18px 50px rgba(0,0,0,.28)' }}>
        <h3 style={{ margin: '0 0 8px', fontSize: 16 }}>Disattivare la linea?</h3>
        <p style={{ margin: '0 0 16px', fontSize: 13.5, lineHeight: 1.55, color: 'var(--muted)' }}>
          {avvisoSpegnimento(linea)}
        </p>
        <p style={{ margin: '0 0 16px', fontSize: 12.5, color: 'var(--faint)' }}>
          Resta configurata: potrai riaccenderla quando vuoi.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary" onClick={onAnnulla}>Annulla</button>
          <button className="btn" onClick={onConferma}>Disattiva</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
